import { render, staticRenderFns } from "./proceedingsInfo.vue?vue&type=template&id=7d5c0eba"
import script from "./proceedingsInfo.vue?vue&type=script&lang=js"
export * from "./proceedingsInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d5c0eba')) {
      api.createRecord('7d5c0eba', component.options)
    } else {
      api.reload('7d5c0eba', component.options)
    }
    module.hot.accept("./proceedingsInfo.vue?vue&type=template&id=7d5c0eba", function () {
      api.rerender('7d5c0eba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/osh/proceedingsInfo.vue"
export default component.exports